import responseService from '../../services/ResponseService';
import { t } from '../../services/i18nService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import questionReader from '../../store/readHelpers/QuestionReader';
import responseReader from '../../store/readHelpers/ResponseReader';
import settingsReader from '../../store/readHelpers/SettingsReader';
import uiReader from '../../store/readHelpers/uiReader';

const oneWayConfirmationModalSelector = {
    selectIsAttempted(question) {
        return !!question && responseReader.isQuestionAttempted(question);
    },

    selectOfferAutocommit(isAttempted, isNotMarkedQuestion) {
        return !isNotMarkedQuestion && isAttempted && settingsReader.shouldOfferAnsweredQuestionsAutocommit()
            && !uiReader.isAnsweredQuestionsAutocommitEnabled();
    },

    selectShowModal(questionId, isOfflineCommitAttempting) {
        const questionResponse = responseReader.getItemResultForQuestion(questionId);
        return responseService.isQuestionCommitAnswerConfirmNeeded(questionResponse) && !isOfflineCommitAttempting;
    },

    selectTitleCaption(isNotMarkedQuestion, isAttempted) {
        if (isNotMarkedQuestion) {
            return t('navigation.oneWay.confirmationModal.titleNotMarked');
        }

        return isAttempted
            ? t('navigation.oneWay.confirmationModal.title')
            : t('navigation.oneWay.confirmationModal.titleBlank');
    },

    selectDescriptionCaption(isNotMarkedQuestion, isAttempted) {
        if (isNotMarkedQuestion) {
            return t('navigation.oneWay.confirmationModal.descriptionNotMarked');
        }

        return isAttempted
            ? t('navigation.oneWay.confirmationModal.description')
            : t('navigation.oneWay.confirmationModal.descriptionBlank');
    },

    selectConfirmCaption(isNotMarkedQuestion) {
        return isNotMarkedQuestion ? t('general.continue') : t('general.submit');
    },

    selectProps(state) {
        const { currentlyShown: { questionId }, response } = state;
        const question = assessmentReader.getQuestion(questionId);
        const isAttempted = this.selectIsAttempted(question);
        const isNotMarkedQuestion = !questionReader.canHaveResult(question);

        return {
            confirmCaption: this.selectConfirmCaption(isNotMarkedQuestion),
            descriptionCaption: this.selectDescriptionCaption(isNotMarkedQuestion, isAttempted),
            offerAutocommit: this.selectOfferAutocommit(isAttempted, isNotMarkedQuestion),
            questionId,
            showModal: this.selectShowModal(questionId, response.isOfflineCommitAttempting),
            titleCaption: this.selectTitleCaption(isNotMarkedQuestion, isAttempted),
        };
    },
};

export default oneWayConfirmationModalSelector;
